import React from 'react'
import { Grid as SemanticGrid } from 'semantic-ui-react'
import omit from 'lodash/omit'

const availableDevices = ['mobile','tablet','computer']

const splitDevices = (only) => {
  if(!only){
    return availableDevices
  }
  const removedValue = only.replace(' large screen widescreen', '')
  return removedValue.split(' ')
}

const isContainInSpecificDevice = (array, device) => array.indexOf(device) !== -1

const createNewSettings = (settings) => {
  const appearDevices = splitDevices(settings.only)
  return availableDevices.reduce(
    (result, device) => {
      return !isContainInSpecificDevice(appearDevices, device) ?
        omit(result, device)
        :
        result
    },
    settings
  )
}

const BaseColumn = ({
  settings,
  children,
  gutter,
}) => {
  const newSettings = createNewSettings(settings)
  return (
    <SemanticGrid.Column {...newSettings} style={{ ...gutter >= 0 && { padding: gutter } }}>
      {children}
    </SemanticGrid.Column>
  )
}

const Column = ({
  renderChildren,
  renderElement,
  ...props,
}) => {
  return (
    renderElement(
      BaseColumn,
      {
        ...props,
        children: renderChildren(),
      }
    )
  )
}

Column.propTypes = {}
Column.defaultProps = {}

export default Column




// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/column/Column.js